import type { ApiQuestion } from '../../../../internalTypes';
import type { ScaleColumn } from '../../../../types/shared';
import { hasNotApplicableOption, hasReverseScaleOrder } from '../shared/configUtils';

export type ResolvedMatrixScaleOptions = {
  scaleColumns: ScaleColumn[];
  scaleAnchorLabels: string[];
  hasNotApplicableOption: boolean;
  reverseScaleOrder: boolean;
};

export function resolveMatrixScaleOptions(
  raw: ApiQuestion,
  configs: { key: string; value?: string[] }[],
  language: string | undefined,
  scaleColumns: ScaleColumn[]
): ResolvedMatrixScaleOptions {
  const notApplicable = hasNotApplicableOption(configs);
  const reverseScaleOrder = hasReverseScaleOrder(configs, raw);

  let scaleAnchorLabels = (raw.answerDetails ?? [])
    .filter(a => a.additional?.isHintText && !a.hidden)
    .map(a => (language && a.translations?.[language]?.answerText) || a.answerText || '')
    .filter(Boolean);

  let resolvedColumns = scaleColumns;
  if (reverseScaleOrder) {
    resolvedColumns = [...scaleColumns].reverse();
    scaleAnchorLabels = [...scaleAnchorLabels].reverse();
  }

  if (notApplicable) {
    resolvedColumns = [...resolvedColumns, { id: 'na', label: 'N/A' }];
  }

  return {
    scaleColumns: resolvedColumns,
    scaleAnchorLabels,
    hasNotApplicableOption: notApplicable,
    reverseScaleOrder,
  };
}
